import { render, staticRenderFns } from "./evaluationform.vue?vue&type=template&id=3805507c&scoped=true&"
import script from "./evaluationform.vue?vue&type=script&lang=js&"
export * from "./evaluationform.vue?vue&type=script&lang=js&"
import style0 from "./evaluationform.vue?vue&type=style&index=0&id=3805507c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805507c",
  null
  
)

export default component.exports